import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { BarChart3 } from "lucide-react";

export default function EmployerAnalytics() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/analytics/employer").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;

  const cards = [
    { key: "active-offers", label: "Offres actives", value: data.totals.active_offers },
    { key: "applications", label: "Candidatures", value: data.totals.applications },
    { key: "interviews", label: "Entretiens planifiés", value: data.totals.interviews_planned },
    { key: "hired", label: "Embauches", value: data.totals.hired },
    { key: "conversion", label: "Conversion embauche", value: `${data.application_to_hire}%` },
  ];

  return (
    <div data-testid="employer-analytics" className="bg-white rounded-xl border border-slate-200 p-6">
      <h2 className="font-semibold text-brand-navy mb-4 flex items-center gap-2">
        <BarChart3 className="w-5 h-5 text-brand-blue" />
        Vue d'ensemble
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
        {cards.map((c) => (
          <div key={c.key} data-testid={`employer-stat-${c.key}`} className="bg-slate-50 rounded-lg p-4">
            <p className="text-2xl font-bold text-brand-navy">{c.value}</p>
            <p className="text-xs text-slate-500 mt-1">{c.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
